import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataTimeMovementType } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_TIME_MOVEMENT_TYPE =
  defineMasterdataEntity<MasterdataTimeMovementType>({
    name: 'time-movement-type',
    responseKey: 'timeMovementTypes',
    displayWith: (t) => keyName(t.key, t.name),
    secondaryWith: (t) => t.symbol,
    icon: 'fa-regular fa-clock',
    title: 'Zeitbewegungsartsuche',
    label: 'Zeitbewegungsart',
    placeholder: 'Zeitbewegungsart suchen...',
    columns: [
      {
        label: 'Zeitbewegungsart',
        type: 'entity',
        icon: 'fa-regular fa-clock',
        value: (t) => keyName(t.key, t.name),
        secondary: (t) => t.symbol,
      },
      { label: 'Schlüssel', type: 'text', value: (t) => t.key },
      { label: 'Bezeichnung', type: 'text', value: (t) => t.name },
      { label: 'Symbol', type: 'text', value: (t) => t.symbol },
      {
        label: 'Arbeitsnachweis',
        type: 'text',
        value: (t) => (t.workReport ? 'Ja' : 'Nein'),
      },
      { label: 'Sortierung', type: 'text', value: (t) => t.sortOrder },
    ],
  });
